module.exports = __webpack_public_path__ + "static/canid_logo-a7d3c1d8b65cfa4bb898f9776b841daa.svg";